export default __webpack_public_path__ + "95273c721d16b614b9d5151780d3f3f0.svg";